export const customTextOption = _TL_('Custom Text');

export const callToActionOptions = [
  customTextOption,
  _TL_('Act Now'),
  _TL_('Apply Now'),
  _TL_('Bet Now'),
  _TL_('Bid Now'),
  _TL_('Book A Car'),
  _TL_('Book Hotel'),
  _TL_('Book Now'),
  _TL_('Build Now'),
  _TL_('Buy Now'),
  _TL_('Chat Now'),
  _TL_('Compare'),
  _TL_('Contact Us'),
  _TL_('Dealers'),
  _TL_('Directions'),
  _TL_('Donate'),
  _TL_('Download'),
  _TL_('Email Now'),
  _TL_('Enroll Now'),
  _TL_('File Now'),
  _TL_('Find Job'),
  _TL_('Find Store'),
  _TL_('Free Play'),
  _TL_('Free Quote'),
  _TL_('Free Trial'),
  _TL_('Get Coupon'),
  _TL_('Get Deals'),
  _TL_('Get Demo'),
  _TL_('Get Offer'),
  _TL_('Get Quote'),
  _TL_('Go To Demo'),
  _TL_('Join Now'),
  _TL_('Learn More'),
  _TL_('Listen Now'),
  _TL_('Log In'),
  _TL_('Order Now'),
  _TL_('Play Game'),
  _TL_('Play Now'),
  _TL_('Post Job'),
  _TL_('Register'),
  _TL_('Renew Now'),
  _TL_('Rent A Car'),
  _TL_('Rent Now'),
  _TL_('Reorder'),
  _TL_('Reserve'),
  _TL_('Save Now'),
  _TL_('Schedule'),
  _TL_('See Demo'),
  _TL_('See Menu'),
  _TL_('See Models'),
  _TL_('See Offer'),
  _TL_('See Offers'),
  _TL_('See Sale'),
  _TL_('Sell Now'),
  _TL_('Shop Now'),
  _TL_('Showtimes'),
  _TL_('Sign In'),
  _TL_('Sign Up'),
  _TL_('Start Now'),
  _TL_('Subscribe'),
  _TL_('Switch Now'),
  _TL_('Test Drive'),
  _TL_('Try Now'),
  _TL_('View Cars'),
  _TL_('View Demo'),
  _TL_('Visit Plans'),
  _TL_('Visit Store'),
  _TL_('Vote Now'),
  _TL_('Watch'),
  _TL_('Watch More'),
  _TL_('Watch Now'),
];
